/**
 * 兼容性前缀与属性的拼接
 * visibilityState -> webkitVisibilityState
 */
export const keyWithPrefix = (prefix: string, key: string) => {
    if (prefix !== '') {
        // 首字母大写
        return prefix + key.slice(0, 1).toUpperCase() + key.slice(1);
    }
    return key;
};

/**
 * 浏览器是否支持 visibilityState
 */
export const isPageVisibilitySupport = () => {
    const prefixs = ['webkit', 'moz', 'ms', 'o', ''];
    return prefixs.some((prefix) => (document as any)[keyWithPrefix(prefix, 'visibilityState')] !== undefined);
};

/**
 * 兼容性前缀
 */
export const getPrefixSupport = () => {
    let prefixSupport = '';
    const prefixs = ['webkit', 'moz', 'ms', 'o', ''];
    for (let index = 0; index < prefixs.length; index++) {
        const prefix = prefixs[index];
        if ((document as any)[keyWithPrefix(prefix, 'visibilityState')] !== undefined) {
            prefixSupport = prefix;
            break;
        }
    }
    return prefixSupport;
};
